// client/src/utils/calendarLinks.js
//
// Build "Add to calendar" URLs for a single event. The .ics download is
// served by the backend (works in email too); Google / Outlook are just
// pre-filled compose links we can construct entirely client-side.

function toCompact(dt) {
  // 2026-09-01T18:30:00Z -> 20260901T183000Z
  const d = new Date(dt);
  if (Number.isNaN(d.getTime())) return '';
  return d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
}

export function googleCalendarUrl({ name, description = '', location = '', start, end }) {
  const s = toCompact(start);
  const e = toCompact(end || start);
  if (!s) return '';
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: name || 'Event',
    dates: `${s}/${e || s}`,
    details: description || '',
    location: location || '',
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function outlookCalendarUrl({ name, description = '', location = '', start, end }) {
  if (!start) return '';
  const params = new URLSearchParams({
    path: '/calendar/action/compose',
    rru: 'addevent',
    subject: name || 'Event',
    body: description || '',
    location: location || '',
    startdt: new Date(start).toISOString(),
    enddt: new Date(end || start).toISOString(),
  });
  return `https://outlook.live.com/calendar/0/deeplink/compose?${params.toString()}`;
}

// icsUrl is provided by the caller (the backend route). This just bundles
// all three for a menu.
export function calendarLinks({ name, description, location, start, end, icsUrl }) {
  return {
    ics: icsUrl || '',
    google: googleCalendarUrl({ name, description, location, start, end }),
    outlook: outlookCalendarUrl({ name, description, location, start, end }),
  };
}
